'use strict';

class TabLinks {
    ui;
    wrap;

    constructor(options) {
        if (options.wrap) {
            this.wrap = options.wrap;
        }

        if (this.wrap) {
            this.ui = {
                inner: $('.js-tab-links-inner'),
                items: $('.js-tab-links-item')
            };

            this.bindUIActions();
        }
    }

    bindUIActions() {
        window.addEventListener('load', () => this.windowLoad());
    }

    windowLoad() {
        this.getPosition();
        this.mobileScrollbar();
    }

    getPosition() {
        let activeItem,
            activeItemOffset,
            windowWidth = window.innerWidth,
            scrollAmount;

        this.ui.items.each((i, item) => {
            if ($(item).hasClass('is-active')) {
                activeItem = $(item);
                activeItemOffset = activeItem.offset().left;
            }
        });

        if (activeItem) {
            if (activeItemOffset > (windowWidth - 150)) {
                scrollAmount = activeItemOffset - 10;
                this.scrollInner(scrollAmount);
            }
        }
    }

    scrollInner(scrollAmount) {
        $(this.ui.inner).scrollLeft(scrollAmount);
    }

    mobileScrollbar() {
        const isTouch = 'ontouchstart' in window || navigator.MaxTouchPoints || navigator.msMaxTouchPoints;

        if (!isTouch) {
            return;
        }

        const outerWidth = this.ui.inner.outerWidth();
        let insideWidth = 0;

        this.ui.items.each((index, el) => {
            insideWidth += $(el).outerWidth(true);
        });

        const scrollWidth = outerWidth/insideWidth;

        this.ui.inner.parent().addClass('is-touch');
        this.ui.inner.parent().append(`<div class="tab-links-scrollbar"><span class="tab-links-scrollbar-thumb" style="width: ${scrollWidth * 100}%;"></span></div>`);

        this.ui.inner.get(0).addEventListener('scroll', () => {
            const scrollOffsetX = this.ui.inner.get(0).scrollLeft / insideWidth * 100;

            this.ui.inner.parent().find('.tab-links-scrollbar-thumb').css('margin-left', scrollOffsetX + '%');
        });
    }
}

export default TabLinks;
